import { create } from "zustand"
import { langStore } from "../../../../stores/lang-store"
import { leakSeverityBundle } from "./leak-severity-const"

export const leakSeverityStore = create((set) => ({
  yLabels: [],
  series: [],

  setChart: (severityInfo) => {
    const yLabels = Object.keys(severityInfo)
    const { lang } = langStore.getState()

    const grouped = {
      minor: [],
      caution: [],
      severe: []
    }

    yLabels.forEach((label) => {
      const row = severityInfo[label]
      grouped.minor.push(row.minor_pct)
      grouped.caution.push(row.caution_pct)
      grouped.severe.push(row.severe_pct)
    })

    const series = leakSeverityBundle.legends.map((key) => ({
      name: key[lang],
      color: key.color,
      data: grouped[key.en]
    }))
    set({ series, yLabels })
  }
}))
